<template>
  <div style="background-color:white;height: 100%;width: 100%;">
    <el-row>
      <el-col :span="12">
        <div style="float:left;margin-right:30px;margin-left:50px;margin-top: 15px;">
          <el-button class="flter-item" type="primary" @click="handleCreate" icon="el-icon-plus">新增</el-button>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="float:left;margin-right:30px;margin-left:50px;margin-top: 15px;">
          <el-button class="flter-item" type="primary" @click="allIn" icon="el-icon-plus">全选</el-button>
          <el-button class="flter-item" type="primary" @click="setCheckedKeys" icon="el-icon-edit">重置</el-button>
          <el-button class="flter-item" type="primary" @click="getCheckedKeys" icon="el-icon-edit">保存</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :span="12">
        <el-table :data="tableData" :border="true" style="width: 80%" ref="multipleTable" tooltip-effect="dark"
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }"
          highlight-current-row @current-change="handleCurrentChange">
          <el-table-column type="index" label="序号" width="100">
          </el-table-column>
          <el-table-column prop="roleName" label="角色名称"> </el-table-column>
          <el-table-column sortable label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="handleCreate2(scope.row)">删除</el-button>
              <el-button @click="handleCreate1(scope.row)" type="text" size="small">修改
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12">
        <div class="down-tree" style="height:600px;border:1px solid #000">
          <el-tree :data="data" show-checkbox :default-expand-all="false" node-key="pageCode" ref="tree"
            :highlight-current="true" @check="handleCheckChange" :props="defaultProps">
          </el-tree>
        </div>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" title="添加角色" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:10%;">
        <el-form-item label="角色名称">
          <el-input placeholder="请输入用户名" v-model="questionForm.roleName" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-preventReClick @click="insertRole">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" title="修改" :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width:60% !important;margin-left: 400px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:10%;">
        <el-form-item label="角色名称">
          <el-input placeholder="请输入用户名" v-model="questionForm.roleName" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" v-preventReClick @click="updateRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectAllPage,
  selectAllRole,
  addRole,
  delRole,
  updRole,
  findByIdRole,
  updateRole
} from "../../api/api";
export default {
  name: "Role",
  data() {
    return {
      data: [],
      defaultProps: {
        children: "rolePages",
        label: "pageName"
      },
      options: [],
      questionForm: {},
      dialogVisible: false,
      dialogVisible1: false,
      form: {
        companyCode: "",
        companyName: "",
        personCode: "",
        newName: ""
      },
      nodeName: "列表",
      // isCheck: true,
      form1: {},
      multipleSelection: [],
      tableData: []
    };
  },
  methods: {
    setRequiredNodeChecked(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].type) {
          this.$refs.tree.setChecked(data[i].code, true)
        }
      }
    },
    setNodeUnChecked(data) {
      for (let i = 0; i < data.length; i++) {
        this.$refs.tree.setChecked(data[i].code, false)
      }
    },
    fetchCheckedNodeParent(data,arr, findKey, callback) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        if (item.pageName && item.pageName === findKey) {
          callback(data)
          return true
        }
        if (item.rolePages && item.rolePages.length) {
          const result = this.fetchCheckedNodeParent(item.childrens, arr,findKey, callback)
          if (result) {
            return true
          }
        }
      }
      return false
    },
    checkRequired(currentData,arr,checkedKeys) {
      const currentKey = currentData.pageCode
      const currentType = currentData.currentType

      if (checkedKeys.includes(currentKey)) {
        // 当前选中
        this.fetchCheckedNodeParent(currentData,arr, '列表', this.setRequiredNodeChecked)
      } else if (currentType) {
        // 取消选中，但当前项是必选项（如果取消勾选的是列表，那么其余同级节点全部取消勾选）
        this.fetchCheckedNodeParent(currentData,arr, '列表', this.setNodeUnChecked)
      }
    },
    // 点击节点
    handleCheckChange(data, node) { 
      let arr 
      node.halfCheckedNodes.forEach((i)=>{
        if(i.pageCode==data.parentCode){
          arr=i
        }
      })
      this.checkRequired(data,arr,node.checkedKeys)
    },
    cancel() {
      this.dialogVisible1 = false;
    },
    updateRole() {
      updateRole(this.questionForm).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogVisible1 = false;
          this.findAllRole();
          this.$message({
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    handleCreate1(row) {
      findByIdRole(row.roleId).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.questionForm = data
        }
      });
      this.dialogVisible1 = true;
    },

    handleCurrentChange(val) {
      this.$refs.tree.setCheckedKeys([]);
      let _this = this
      findByIdRole(val.roleId).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
        } else if (status == 200) {
          _this.form1 = data
          if (_this.form1.menuId != [] && _this.form1.menuId != null) {
            var arr = _this.form1.menuId.split(",")
            arr.forEach((i) => {
              let node = _this.$refs.tree.getNode(i)
              if (node.isLeaf) {
                _this.$refs.tree.setChecked(node, true);
              }
            })
          }
        }
      });
      // this.form1.roleId=val.roleId
    },
    getCheckedKeys() {
      var s = this.$refs.tree.getCheckedKeys();
      var p = this.$refs.tree.getHalfCheckedKeys()

      console.log(s)
      console.log(p)
      var list = s.concat(p)
      this.form1.list = list;
      updRole(this.form1).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          // this.findAllRole();
          this.$message({
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    setCheckedKeys() {
      this.$refs.tree.setCheckedKeys([]);
    },
    allIn() {
      var name = [];
      for (var i = 0; i < this.data.length; i++) {
        name.push(this.data[i].pageCode);
      }
      this.$refs.tree.setCheckedKeys(name);
    },
    handleCreate() {
      this.dialogVisible = true;
      this.questionForm = {};
    },
    insertRole() {
      addRole(this.questionForm).then(datas => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogVisible = false;
          this.findAllRole();
          this.$message({
            message: "添加成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //删除选中单位
    handleCreate2(row) {
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var a = [];
          a.push(row.roleId)
          delRole(a).then(datas => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "warning"
              });
            } else if (status == 200) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.findAllRole();
            } else {
              this.$message({
                message: "请求错误",
                type: "error"
              });
            }
          });
        })
    },
    findAll() {
      selectAllPage().then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          this.data = data;
        }
      });
    },
    findAllRole() {
      selectAllRole().then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          this.tableData = data;
        } 
      });
    }
  },
  created() {
    this.findAll();
    this.findAllRole();
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.down-tree {
  display: block;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/SystemSettings/Role.vue